import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { PAGE_NAMES } from '../../../core/helpers/constants';
import { IPermission } from '../../../core/models/auth.models';
import { ITag } from '../../../core/models/tags.models';
import { AppService } from '../../../store/app.service';
import { EditTagComponent } from '../edit-tag/edit-tag.component';
import { TagsApiService } from '../tags.apiservice';
import { ISearch } from '../../../core/models/search.model';
@Component({
  selector: 'app-tags',
  templateUrl: './tags-main.component.html',
  styleUrls: ['./tags-main.component.scss']
})
export class TagsMainComponent implements OnInit {
  doWhat: IPermission = {} as IPermission;
  columns = [
    { title: 'NAME', field: 'name', sortable: true, searchable: true, translate: true },
    { title: 'DESCRIPTION', field: 'description', sortable: true, searchable: true, translate: true },
    { title: 'CATEGORIES', field: 'categories', searchable: true, translate: true },
  ]
  tagsData: Array<ITag>
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private savedSearchId: string | null = null;
  tagSavedSearches: ISearch[] = [];
  selectedSavedSearchId: string | null = null;
  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private tagService: TagsApiService,
    private appService: AppService) {
    this.tagsData = new Array<ITag>();
  }

  ngOnInit(): void {
    this.appService.setPageTitle$('TAGS');
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Tags);
    this.appService.getAllTags$()
      .pipe(takeUntil(this.destroyed$)
      )
      .subscribe((response: Array<ITag>) => {
        this.tagsData = [...response];
      });
    this.savedSearchId = this.route.snapshot.queryParams['savedsearchid'];
    this.loadSavedSearches();
    this.refreshTags();
  }

  private loadSavedSearches() {
    this.appService.fetchSearches();
    this.appService.getAllSearches$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((searches: ISearch[]) => {
        this.tagSavedSearches = (searches || [])
          .filter(search => search.resultType?.toLowerCase() === 'tag');
        this.selectedSavedSearchId = this.tagSavedSearches.some(search => search.id === this.savedSearchId)
          ? this.savedSearchId
          : null;
      });
  }

  onSavedSearchChange(savedSearchId: string | null) {
    this.selectedSavedSearchId = savedSearchId || null;
    this.savedSearchId = savedSearchId || '';
    this.refreshTags();
  }

  editRow(evt: any) {
    this.openEditTagModal(evt.id);
  }
  deleteRows(evt: any) {
    this.tagService.deleteTag(evt)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.refreshTags();
      })
  }

  onAddNew() {
    this.openEditTagModal();
  }

  onClientRowClick(evt: any) {
    //this.router.navigate(['/pages/tag-details', evt.id]);
  }

  ngAfterViewInit() {

  }

  private openEditTagModal(id?: string) {
    const dialogRef = this.modalService.open(EditTagComponent, { backdrop: 'static' });
    dialogRef.componentInstance.iId = id ?? null;
    dialogRef.componentInstance.oSaveClicked.subscribe(() => {
      this.refreshTags();
    });
  }

  private refreshTags() {
    this.appService.fetchAllTags(this.savedSearchId);
  }

}
